import { render, staticRenderFns } from "./Onlink.vue?vue&type=template&id=24f7b5e2"
import script from "./Onlink.vue?vue&type=script&lang=js"
export * from "./Onlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports